<script setup lang="ts">
import { watch } from 'vue'
import { useCookieConsentStore } from '~/stores/useCookieConsentStore'

const { category } = defineProps<{
  category?: string
}>()

const ccStore = useCookieConsentStore()

const nuxtApp = useNuxtApp()
const { data: podcasts, execute } = useAsyncData(
  'podcasts-local' + (category ? '-' + category : ''),
  () =>
    $fetch('/api/podcasts/', {
      params: {
        countryCode: ccStore.gdpr?.country,
        category: category ? category : '',
      },
    }),
  {
    getCachedData(key) {
      return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
    },
    server: false,
    immediate: false,
  }
)

watch(
  () => ccStore.gdpr,
  () => {
    if (ccStore.gdpr && !!ccStore.gdpr?.country && !podcasts.value) {
      execute()
    }
  },
  { immediate: true }
)
</script>

<template>
  <MediaListRow
    v-if="!ccStore.gdpr || !!ccStore.gdpr?.country"
    :items="podcasts?.data"
    title="Popular Local Podcasts"
    type="podcasts"
  />
</template>

<style scoped></style>
